import { cloneDeep, get } from 'lodash';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';

import { REDUX_STORE } from '@funnels/constants';
import { FetchCreditReportAction, ReduxStoreData, StoreApplicant, StoreCreditReport } from '@funnels/types';
import { datadogUtil } from '@funnels/utils';

import { waitForAuth, waitForResourcesToBeFree } from '../_common';
import {
  fetchCreditReport,
  fetchCreditReportFail,
  fetchCreditReportsFail,
  fetchCreditReportsSuccess,
  fetchCreditReportSuccess,
} from '../actions';
import CreditReportAPI from './api';

export function* fetchCreditReportWorker(action: FetchCreditReportAction): any {
  try {
    yield waitForAuth();
    const { applicantId } = action;
    const response = yield call(CreditReportAPI.fetch, applicantId);

    yield put(fetchCreditReportSuccess(applicantId, response as StoreCreditReport));
  } catch (e: any) {
    datadogUtil.addError(e);
    yield put(fetchCreditReportFail(get(e, 'response.data.message', e.message)));
  }
}

export function* fetchAllCreditReportsWorker(): any {
  try {
    yield waitForAuth();

    let reduxStoreApplicants = yield select((state: ReduxStoreData) => state.applicants.data);
    yield waitForResourcesToBeFree(['applicants']);
    reduxStoreApplicants = yield select((state: ReduxStoreData) => state.applicants.data);

    yield all(
      cloneDeep(reduxStoreApplicants).map((storeApplicant: StoreApplicant) =>
        put(fetchCreditReport(storeApplicant.clientId))
      )
    );

    yield put(fetchCreditReportsSuccess());
  } catch (e: any) {
    datadogUtil.addError(e);
    yield put(fetchCreditReportsFail(e.message));
  }
}

export function* creditReportsWatcher() {
  yield takeEvery(REDUX_STORE.CREDIT_REPORTS.ACTION_TYPES.FETCH_CREDIT_REPORT, fetchCreditReportWorker);
  yield takeEvery(REDUX_STORE.CREDIT_REPORTS.ACTION_TYPES.FETCH_CREDIT_REPORTS, fetchAllCreditReportsWorker);
}

export default creditReportsWatcher;
